
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialSection from './TestimonialKeyword';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';function Cabbookingformarriagefunction() {



    const cardData =
    {
        keyword: ' Cab Booking for Marriage function in Pune',
        heading: 'Prince Cabs: Cab Booking for Marriage function in Pune',
        headingDescription: 'Prince Cabs offers reliable Cab Booking for Marriage Function in Pune, ensuring smooth, stylish, and convenient travel for your special occasion. Our fleet includes luxury sedans, spacious SUVs, and premium cars like Innova Crysta and Kia Carens, ideal for bridal entry, family travel, and guest transportation. With professional chauffeurs, punctual pickups, and flexible booking options, we make wedding travel arrangements hassle-free. Add elegance, comfort, and reliability to your celebrations with Prince Cabs’ trusted marriage function cab booking service in Pune.',

        top: 'Top Places to Visit in Pune with Prince Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732, was the majestic seat of the Peshwas of the Maratha Empire. Its grand stone walls, massive gates, and sprawling courtyards narrate tales of bravery and politics. Though partially destroyed by fire in 1828, its ruins still showcase Pune’s glorious past. The evening light-and-sound show recreates Maratha history with drama and pride. Visitors enjoy exploring the gardens and old fortifications. Shaniwar Wada remains Pune’s most iconic landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is one of Pune’s most treasured monuments. During the Quit India Movement, Mahatma Gandhi and Kasturba Gandhi were imprisoned here. Today, the palace houses a museum with photographs, letters, and personal artifacts of Gandhi. Its vast lawns provide a peaceful retreat for visitors. The monument is recognized as a national heritage site. It is a timeless symbol of sacrifice and patriotism."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, about 30 km from Pune, is known for the 1670 battle where Tanaji Malusare fought bravely for the Marathas. The fort’s ruins, bastions, and watchtowers offer glimpses into history. Trekkers love the scenic climb, especially during monsoon when the hills turn lush green. From the top, views of the Sahyadri ranges are breathtaking. Local vendors serve traditional pithla-bhakri, enhancing the experience. Sinhagad is a mix of history, adventure, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "The Dagdusheth Halwai Ganapati Temple is Pune’s most famous religious site, dedicated to Lord Ganesha. The idol, adorned with gold ornaments, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of cultural celebrations. It is also known for its charitable contributions and social work. Its central location makes it easily accessible for locals and tourists. It is both a spiritual and cultural icon of Pune."
  },
  {
    "title": "Parvati Hill",
    "description": "Parvati Hill is one of Pune’s highest points, offering sweeping views of the city. At the summit lies the Parvati Temple complex, dedicated to Lord Shiva and Goddess Parvati. Visitors climb over 100 steps to reach this spiritual and historical site. The Peshwa Museum nearby displays Maratha-era artifacts. Sunrises and sunsets from the hill are especially enchanting. Parvati Hill blends devotion, heritage, and natural beauty."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Dating back to the 8th century, Pataleshwar Cave Temple is a rock-cut shrine dedicated to Lord Shiva. It features massive stone pillars, a sanctum with a Shiva linga, and a stone-carved Nandi. Despite being in the city center, it offers a calm and meditative environment. The temple reflects Rashtrakuta-era architectural brilliance. Visitors admire its historical and spiritual charm. It is one of Pune’s hidden heritage gems."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum showcases over 20,000 artifacts collected by Dr. Dinkar Kelkar. Its exhibits include sculptures, paintings, musical instruments, and everyday objects from across India. A highlight is the recreated Mastani Mahal, reflecting Maratha history. The museum fascinates both art lovers and history buffs. It reflects the cultural richness of Maharashtra. This museum is one of Pune’s most unique attractions."
  },
  {
    "title": "Osho Ashram (Koregaon Park)",
    "description": "The Osho International Meditation Resort in Koregaon Park is a global retreat for wellness and spirituality. Visitors from across the world come here for meditation, yoga, and therapy programs. Surrounded by serene gardens and modern architecture, it offers peace and relaxation. The ashram promotes holistic growth and mindfulness. Its vibrant international community adds cosmopolitan flavor. It is a unique blend of spirituality and lifestyle."
  },
  {
    "title": "Phoenix Marketcity",
    "description": "Phoenix Marketcity in Viman Nagar is Pune’s largest shopping and lifestyle destination. It houses global and Indian retail brands, multiplex cinemas, and entertainment zones. The mall also offers gourmet dining experiences and seasonal events. Families love it for a complete day of shopping and leisure. It represents the modern and urban side of Pune. Phoenix Marketcity is the city’s ultimate retail hub."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, about 20 km from Pune, is a favorite picnic and weekend spot. It provides water to the city and is surrounded by scenic hills. Families enjoy street food, boating, and evening walks here. The monsoon season transforms it into a lush paradise with misty views. Cool breezes make evenings refreshing by the waterside. Khadakwasla is Pune’s peaceful natural retreat."
  },
  {
    "title": "Mulshi Lake",
    "description": "Mulshi Lake, formed by the Mulshi Dam, is a serene destination near Pune. Surrounded by forests, waterfalls, and Sahyadri hills, it is perfect for camping and photography. Monsoon enhances its beauty with greenery and mist. Eco-resorts nearby offer a cozy stay for families and couples. Trekkers also love its trails and scenic landscapes. Mulshi is an ideal spot for nature and relaxation."
  },
  {
    "title": "Chaturshringi Temple",
    "description": "Chaturshringi Temple, on Senapati Bapat Road, is one of Pune’s oldest shrines dedicated to Goddess Chaturshringi. Devotees climb more than 100 steps to reach the sanctum. The temple is vibrant during Navratri with cultural and religious festivities. Thousands of pilgrims visit to seek blessings year-round. Its hilltop setting offers panoramic city views. It is both a spiritual and cultural landmark."
  },
  {
    "title": "National War Memorial Southern Command",
    "description": "The National War Memorial in Pune honors soldiers who sacrificed their lives post-independence. It displays tanks, weapons, and war memorabilia. A museum inside narrates stories of India’s military history. The evening flag retreat ceremony is deeply moving. Families and students visit to pay respects and learn patriotism. It is a place of pride and remembrance for the armed forces."
  },
  {
    "title": "Empress Garden",
    "description": "Empress Garden, spread across 39 acres, is a botanical park with exotic plants and shaded walkways. Managed by the Agri-Horticultural Society, it is one of Pune’s oldest gardens. Families visit for picnics, leisure walks, and relaxation. The annual flower show is a major attraction for nature lovers. Its colonial heritage adds historical charm. Empress Garden is a peaceful green escape within the city."
  },
  {
    "title": "Vetal Tekdi (Vetal Hill)",
    "description": "Vetal Tekdi, the highest hill in Pune, is a favorite among joggers, cyclists, and nature lovers. The hilltop offers sweeping views of the entire city. It is rich in biodiversity, with birds and native flora adding to its charm. Sunrises and sunsets from here are especially captivating. Locals come for morning yoga and fitness activities. Vetal Hill is Pune’s natural lung and a serene retreat."
  }
],

"services": [
  {
    "name": "Marriage Function Car Hire Pune",
    "description": "Book well-maintained cars for marriage functions in Pune with a variety of options including sedans, SUVs, MPVs, and luxury cars. Ensure smooth transportation for the bride, groom, guests, and family members with comfortable and stylish vehicles driven by professional chauffeurs."
  },
  {
    "name": "Wedding Cab Pune",
    "description": "Reliable and timely wedding cab services in Pune for all your marriage transportation needs. Whether it’s for baraat, guest pickups, or bridal entry, choose from a fleet of clean, well-kept cabs that suit both budget and luxury preferences."
  },
  {
    "name": "Crysta for Marriage Event Pune",
    "description": "Hire Innova Crysta for wedding events in Pune, offering premium comfort and ample space for guests or family travel. Ideal for long-distance trips or moving between venues with elegance and ease."
  },
  {
    "name": "Sedan Cabs for Marriage Guests Pune",
    "description": "Comfortable and presentable sedan cabs like Dzire and Etios available for wedding guest transportation in Pune. Ensure timely arrival and drop for guests attending various ceremonies throughout the day."
  },
  {
    "name": "Family Cab for Marriage Pune",
    "description": "Spacious and reliable cab services in Pune specially suited for families attending wedding functions. Choose 6 or 7-seater options to keep families traveling together in comfort and style."
  },
  {
    "name": "SUV Hire for Marriage Pune",
    "description": "Rent spacious SUVs in Pune for wedding occasions, offering a perfect blend of style and utility for transporting guests or family members to the venue. Great for rural weddings or long routes."
  },
  {
    "name": "Ertiga for Marriage Cab Booking",
    "description": "Book 7-seater Ertiga cars for wedding functions in Pune. Perfect for ferrying groups of guests or family members with ample luggage space and air-conditioned comfort."
  },
  {
    "name": "Marriage Function Cab with Driver Pune",
    "description": "Driver-included cab rentals for marriage functions in Pune, ensuring worry-free logistics. Professional drivers manage pickups, drops, and on-time arrival at multiple venues across the city or outstation."
  },
  {
    "name": "Innova for Shaadi in Pune",
    "description": "Premium Innova cabs for Pune weddings that offer comfort, space, and a touch of class. Suitable for VIP guests, elderly relatives, or for the couple’s travel to and from ceremonies."
  },
  {
    "name": "Pune Marriage Pickup Drop Taxi",
    "description": "Efficient pickup and drop taxi services for marriage events in Pune. Manage guest arrivals, hotel transfers, and back-and-forth movement to the wedding venue with ease and punctuality."
  },
  {
    "name": "Luxury Cars for Marriage Pune",
    "description": "Choose from a selection of luxury cars like BMW, Audi, and Mercedes for your wedding day in Pune. Make an impression with chauffeur-driven premium cars tailored for bridal and groom entry."
  },
  {
    "name": "Wedding Guest Cab Hire Pune",
    "description": "Organize bulk cab bookings for wedding guests in Pune. Multiple sedan, SUV, and MPV options available for coordinated pickups and drops across venues and accommodations."
  },
  {
    "name": "Dzire for Marriage Cab Service Pune",
    "description": "Hire Dzire cabs in Pune for a budget-friendly and neat solution to wedding guest travel. Suitable for short-distance hotel to venue commutes and staff movement during events."
  },
  {
    "name": "Affordable Marriage Cab Booking",
    "description": "Budget-conscious cab rental options for weddings in Pune that do not compromise on service quality. Clean cars, trained drivers, and timely service for guests and family alike."
  },
  {
    "name": "Large Vehicle for Marriage Party Pune",
    "description": "Hire large-capacity vehicles like Tempo Travellers or 7+ seaters in Pune for transporting bigger groups to wedding venues. A cost-effective and practical solution for group travel on the big day."
  }
],
"tableData": [
  ["Marriage Function Car Hire Pune", "Wedding Cab Pune"],
  ["Crysta for Marriage Event Pune", "Sedan Cabs for Marriage Guests Pune"],
  ["Family Cab for Marriage Pune", "SUV Hire for Marriage Pune"],
  ["Ertiga for Marriage Cab Booking", "Marriage Function Cab with Driver Pune"],
  ["Innova for Shaadi in Pune", "Pune Marriage Pickup Drop Taxi"],
  ["Luxury Cars for Marriage Pune", "Wedding Guest Cab Hire Pune"],
  ["Dzire for Marriage Cab Service Pune", "Affordable Marriage Cab Booking"],
  ["Large Vehicle for Marriage Party Pune"]
],


"whychoose": [
  {
    "WhyChooseheading": "Reliable Cab Service for Marriage Functions in Pune",
    "WhyChoosedescription": "Prince Cabs offers professional and dependable cab services tailored specifically for marriage functions in Pune. Whether it’s transporting the bride and groom, family members, or guests, we ensure timely pickups, smooth coordination, and comfortable rides to and from all wedding venues, helping your celebrations run without stress or delay."
  },
  {
    "WhyChooseheading": "Fleet of Vehicles to Suit All Wedding Requirements",
    "WhyChoosedescription": "Choose from a wide variety of well-maintained vehicles including sedans, SUVs, Ertiga, Innova Crysta, and even luxury cars for VIP guests or bridal entry. Our diverse fleet can cater to all types of needs—guest shuttles, airport pickups, mandap transfers, and intercity travel—making us a one-stop solution for all wedding-related transportation."
  },
  {
    "WhyChooseheading": "Custom Packages for Single or Multi-Day Events",
    "WhyChoosedescription": "Whether it's a one-day wedding or a 3-day celebration with Sangeet, Haldi, and Reception, we offer customizable cab packages to match your schedule. Book by the hour, per day, or for the entire function. Our team helps plan logistics so that your guests and family travel seamlessly between venues."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Smooth Guest Experience",
    "WhyChoosedescription": "Our professional and uniformed drivers are well-trained, punctual, and courteous. They are experienced in handling event logistics and are familiar with major wedding venues across Pune. From assisting elderly guests to coordinating drop-offs at multiple locations, they provide polite and attentive service throughout."
  },
  {
    "WhyChooseheading": "Transparent and Flexible Pricing",
    "WhyChoosedescription": "We offer transparent, competitive pricing that includes fuel, driver allowance, tolls, and taxes—no hidden charges. Whether you're booking one cab or a full fleet, you’ll receive clear quotes upfront. Payments can be made via UPI, debit/credit cards, net banking, or cash."
  },
  {
    "WhyChooseheading": "Sanitized, Decor-Ready, and Well-Maintained Vehicles",
    "WhyChoosedescription": "All our cabs are fully sanitized before every trip and kept in excellent condition. For special moments like the bride and groom’s entry or VIP arrivals, we can provide decor-ready vehicles upon request to enhance the occasion’s elegance and visual appeal."
  },
  {
    "WhyChooseheading": "24/7 Support and Real-Time Coordination",
    "WhyChoosedescription": "Our dedicated wedding support team and 24/7 helpline ensure real-time coordination between vehicles and guests. We handle last-minute changes, unexpected delays, and any travel-related issues to ensure the transportation part of your marriage function is entirely stress-free."
  }
]
































    }

const faqData = [
    {
        question: 'Does Prince Cabs offer cab services for marriage functions in Pune?',
        answer: 'Yes, Prince Cabs provides reliable and comfortable cab services for marriage functions in Pune, including guest pick-up, drop, and event transportation.',
    },
    {
        question: 'What types of vehicles are available for wedding-related cab bookings?',
        answer: 'We offer a wide range of vehicles such as Swift Dzire, Ertiga, Innova, Tempo Traveller, and luxury sedans/SUVs to suit different needs.',
    },
    {
        question: 'Can Prince Cabs handle multiple cab bookings for marriage functions?',
        answer: 'Absolutely! We specialize in managing bulk cab bookings and seamless coordination for weddings and large family gatherings.',
    },
    {
        question: 'Are the cabs clean and suitable for special occasions like weddings?',
        answer: 'Yes, all our cabs are well-maintained, sanitized, and presentable—perfect for any marriage function or celebration.',
    },
    {
        question: 'Is it possible to hire decorated cabs for the bride and groom?',
        answer: 'Yes, we offer the option to arrange decorated or premium vehicles for the bride, groom, or VIP guests upon request.',
    },
    {
        question: 'What are the charges for booking cabs for marriage functions in Pune?',
        answer: 'Charges vary based on vehicle type, quantity, and duration. Contact Prince Cabs for customized packages and competitive pricing.',
    },
    {
        question: 'How can I book cabs for a marriage function in Pune?',
        answer: 'You can book easily through our website or by contacting our customer support to discuss your specific event transportation needs.',
    },
];

const testimonials = [
    {
        name: "Mr. Pranav Kulkarni",
        position: "Wedding Planner",
        text: "Prince Cabs made transport for the marriage function completely stress-free. Every cab arrived on time and the guests were happy.",
        image: "/img/testimonial/testimonial-thumb-marriage-pune-1.png",
    },
    {
        name: "Mrs. Swati Patil",
        position: "Mother of the Bride",
        text: "We booked multiple cabs for our daughter’s marriage function. Prince Cabs provided excellent service and managed everything smoothly.",
        image: "/img/testimonial/testimonial-thumb-marriage-pune-2.png",
    },
];













































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9284304420",
            "+91 8308844163",


        ],
        email: "booking@princecab.com"
    };


    const Images = [
  { place: "/images/keyword/1.jpg",  text: "Innova Cab on Rent in Hadapsar Pune",            link: "innova-cab-on-rent-in-hadapsar-pune" },
  { place: "/images/keyword/2.jpg",  text: "Pune To Mahabaleshwar Innova Cab",                link: "pune-to-mahabaleshwar-innova-cab" },
  { place: "/images/keyword/3.jpg",  text: "Pune to Shirdi Innova Cab Booking",               link: "pune-to-shirdi-innova-cab-booking" },
  { place: "/images/keyword/4.jpg",  text: "Pune to Mumbai Airport Innova Cab",               link: "pune-to-mumbai-airport-innova-cab" },
  { place: "/images/keyword/5.jpg",  text: "Pune to Goa Innova Cab",                          link: "pune-to-goa-innova-cab" },
  { place: "/images/keyword/6.jpg",  text: "Pune to Ashtavinayak Innova Tour Package",        link: "pune-to-ashtavinayak-innova-tour-package" },
  { place: "/images/keyword/7.jpg",  text: "Sedan Cab Service in Pune",                       link: "sedan-cab-service-in-pune" },
  { place: "/images/keyword/8.jpg",  text: "Etios Cab for Outstation in Pune",                link: "etios-cab-for-outstation-in-pune" },
  { place: "/images/keyword/9.jpg",  text: "Toyota Etios Cab Booking in Pune",                link: "toyota-etios-cab-booking-in-pune" },
  { place: "/images/keyword/10.jpg", text: "Swift Dzire On Rent Pune",                        link: "swift-dzire-on-rent-pune" },
  { place: "/images/keyword/11.jpg", text: "Pune to Shirdi Swift Dzire Cab",                  link: "pune-to-shirdi-swift-dzire-cab" },
  { place: "/images/keyword/12.jpg", text: "Pune to Mahabaleshwar Swift Dzire Cabs",          link: "pune-to-mahabaleshwar-swift-dzire-cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Dzire Cab",                        link: "pune-to-mumbai-dzire-cab" },
  { place: "/images/keyword/14.jpg", text: "Pune to Gujarat Cab",                             link: "pune-to-gujarat-cab" },
  { place: "/images/keyword/15.jpg", text: "Pune to Rajasthan Cab",                           link: "pune-to-rajasthan-cab" },
  { place: "/images/keyword/16.jpg", text: "Pune to Indore Cab Booking",                      link: "pune-to-indore-cab-booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Vijayawada Cabs",                         link: "pune-to-vijayawada-cabs" },
  { place: "/images/keyword/18.jpg", text: "Pune to Bangalore Cab",                           link: "pune-to-bangalore-cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Hyderabad Cab",                           link: "pune-to-hyderabad-cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Belgaum Cab",                             link: "pune-to-belgaum-cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mahabaleshwar Cab",                       link: "pune-to-mahabaleshwar-cab" },
  { place: "/images/keyword/22.jpg", text: "Pune to Panchgani Cab",                           link: "pune-to-panchgani-cab" },
  { place: "/images/keyword/23.jpg", text: "Pune to Goa Cab",                                 link: "pune-to-goa-cab" },
  { place: "/images/keyword/24.jpg", text: "Pune to Bhimashankar Cab",                        link: "pune-to-bhimashankar-cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Shirdi Cab",                              link: "pune-to-shirdi-cab" },
];




    const images = [
        { src: "/images/gallery/1.jpg", alt: "Image 1" },
        { src: "/images/gallery/5.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/4.jpg", alt: "Image 1" },
        { src: "/images/gallery/6.jpg", alt: "Image 1" },

    ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Cab Booking for Marriage Function in Pune",
  "description": "Affordable and reliable cab booking services for marriage functions in Pune including Crysta, Sedan, SUV, Ertiga, Innova, Dzire, and luxury cars with driver for pickup and drop services.",
  "provider": {
    "@type": "LocalBusiness",
    "name": "Prince Cabs",
    "telephone": "+91-XXXXXXXXXX",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Pune",
      "addressRegion": "Maharashtra",
      "addressCountry": "IN"
    }
  },
  "serviceType": [
    "Marriage Function Car Hire Pune",
    "Wedding Cab Pune",
    "Crysta for Marriage Event Pune",
    "Sedan Cabs for Marriage Guests Pune",
    "Family Cab for Marriage Pune",
    "SUV Hire for Marriage Pune",
    "Ertiga for Marriage Cab Booking",
    "Marriage Function Cab with Driver Pune",
    "Innova for Shaadi in Pune",
    "Pune Marriage Pickup Drop Taxi",
    "Luxury Cars for Marriage Pune",
    "Wedding Guest Cab Hire Pune",
    "Dzire for Marriage Cab Service Pune",
    "Affordable Marriage Cab Booking",
    "Large Vehicle for Marriage Party Pune"
  ],
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  }
};






    return (
        <div>
<Helmet>
  <title>Cab Booking for Marriage Function in Pune | Affordable & Luxury Cars</title>
  <meta
    name="description"
    content="Book affordable and reliable cabs for marriage functions in Pune including Crysta, Sedan, SUV, Ertiga, Innova, Dzire, and luxury cars with driver for pickup and drop services."
  />
  <meta
    name="keywords"
    content="Marriage Function Car Hire Pune, Wedding Cab Pune, Crysta for Marriage Event Pune, Sedan Cabs for Marriage Guests Pune, Family Cab for Marriage Pune, SUV Hire for Marriage Pune, Ertiga for Marriage Cab Booking, Marriage Function Cab with Driver Pune, Innova for Shaadi in Pune, Pune Marriage Pickup Drop Taxi, Luxury Cars for Marriage Pune, Wedding Guest Cab Hire Pune, Dzire for Marriage Cab Service Pune, Affordable Marriage Cab Booking, Large Vehicle for Marriage Party Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: 'url(/images/inner-banner.jpg)' }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">{cardData.keyword} </h1>
                        </div>
                    </div>
                </div>
                <div className="inner-shape"></div>
            </section>







            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/71.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#AF3125', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                             <div className="topPlaces">
  <p className="sectionLead">{cardData.top}</p>

  {cardData.topPlaces.map((place, index) => (
    <article key={index} className="placeCard" tabIndex="0">
      <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

      <div className="placeBody">
        <h4 className="placeTitle">{place.title}</h4>
        <p className="placeDesc">{place.description}</p>
      </div>

      <span className="placeArrow" aria-hidden>›</span>
    </article>
  ))}
</div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vihaan Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialSection testimonials={testimonials} />


 <ContactShowcase/>
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
  {Images.map((e, i) => {
    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

    return (
      <a
        key={e.link || i}
        href={href}
        className="routeItem"
        aria-label={e.text}
        {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
      >
        <div className="routeThumb">
          <img src={e.place} alt="" loading="lazy" />
        </div>

        <div className="routeMeta">
          <h6 className="routeTitle">{e.text}</h6>
          <span className="routeUnderline" />
        </div>

        <span className="routeArrow" aria-hidden>›</span>
      </a>
    );
  })}
</div>



                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                        </div> */}
<div>
  <FleetHighway/>
</div>
                            <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919284304420" className="pc-call">+91 9284304420</a>
        <a href="tel:+918308844163" className="pc-call">+91 8308844163</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919284304420"
          target="_blank" rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp me-1"></i> WhatsApp
        </a>
        <a href="tel:+919284304420" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@princecab.com" className="pc-email">
        booking@princecab.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-house-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Prince Cabs</strong><br />
        Office No 106, 2nd Floor, Nilgiri Nest Co-op Housing Society,<br />
        Pimple Gurav, Pune, Pin - 411027
      </address>
    </section>
  </div>
</div>



                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabbookingformarriagefunction ;